// ==================== BRAND CONFIG ====================
// Central place for all brand text. Override per deployment with build-time
// env vars (REACT_APP_BRAND_*, see .env.example). Defaults are TenisCG so
// existing builds render identically. The accent colour lives in
// tailwind.config.js (the `brand` palette), not here.
const env = process.env;

const name = env.REACT_APP_BRAND_NAME || 'TenisCG';
const accent = env.REACT_APP_BRAND_ACCENT || '.me';

export const BRAND = {
  name,                 // e.g. "TenisCG"
  accent,               // e.g. ".me" (rendered in the brand colour)
  fullName: `${name}${accent}`,                    // "TenisCG.me"
  domain: env.REACT_APP_BRAND_DOMAIN || 'teniscg.me',
  url: env.REACT_APP_BRAND_URL || 'https://teniscg.me',
  tagline: env.REACT_APP_BRAND_TAGLINE || 'Rekreativni tenis Crne Gore',
  description:
    env.REACT_APP_BRAND_DESCRIPTION ||
    'Platforma za rekreativni tenis u Crnoj Gori. Rang liste, turniri, lige i više.',
  // Hero headline is split into a plain line + an accent-coloured line.
  heroTitle: env.REACT_APP_BRAND_HERO_TITLE || 'Rekreativni tenis',
  heroAccent: env.REACT_APP_BRAND_HERO_ACCENT || 'Crne Gore',
};
